import React, { useContext, useEffect, useState } from 'react';

import _ from 'lodash';
import cx from 'classnames';

import { Input } from "src/components/input";
import { CollectionEditState } from "src/types/collections";

import styles from './name.module.scss';
import { CollectionContext } from '../context';
import { useSelector } from 'react-redux';


interface CollectionNameProps {
  className?: string;
  collection: CollectionEditState,
}

const CollectionName: React.FC<CollectionNameProps> = ({ collection, className }) => {
  const collectionContext = useContext(CollectionContext);

  const name = _.get(collection, 'subject') || '';
  const [active, setActive] = useState(false);

  const originalName = useSelector((state: any) => {
    return _.get(state, `${collectionContext.itemSelector}.subject`, null);
  });

  const handleChange = (e) => {
    const value = e.target.value;
    collectionContext.updateCollectionProperty('subject', value);
  }

  useEffect(() => {
    if(!active && collection){
      if(name === '' && originalName){
        collectionContext.updateCollectionProperty('subject', originalName);
      }
    }
  }, [active]);

  return (
    <div className={cx(styles.nameInput, className, {
      [styles.active]: active
    })}>
      <label>Collection Name: </label>
      <input className={styles.input} 
        value={name} 
        placeholder='Provide a conversation name'
        onFocus={() => setActive(true)}
        onBlur={() => setActive(false)}
        onChange={handleChange}
      />
    </div>
  );
}

export { CollectionName };